$(document).ready(function(){

  //mega menu 
  $('ul.list-menu.list-menu--inline li.itg_sidebar_style_menu .mega-menu__content ul.mega-menu__list li:first-child').addClass('active');
  $('ul.list-menu.list-menu--inline li.itg_sidebar_style_menu .mega-menu__content ul.mega-menu__list li').mouseover(function(){
      $(this).parents('ul.mega-menu__list').find('li.active').removeClass('active');
      $(this).addClass('active');
  
  });
//menu hover 
  $('.header nav.header__inline-menu li.itg_sidebar_style_menu').mouseover(function() {
    $('.header nav.header__inline-menu li.itg_sidebar_style_menu .mega-menu').attr('open', false);
    $(this).find('.mega-menu').attr('open', true);
    $(this).find('.fhNUrG').addClass('dTnuRg');
    $(this).find('.jYVJqC').addClass('dTnuRg');
  });
  $('.header nav.header__inline-menu li.itg_sidebar_style_menu').mouseout(function(){   
   $('.header nav.header__inline-menu li.itg_sidebar_style_menu .mega-menu').attr('open', false);
   $(this).find('.fhNUrG').removeClass('dTnuRg');
   $(this).find('.jYVJqC').removeClass('dTnuRg');
  });
  
 // feature collection slider 
  $('.feature-slide').slick({
    centerMode: true,
    centerPadding: '20px',
    slidesToShow: 5,
    slidesToScroll: 1,
    centerMode: true,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg width="19" height="16" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.8301 20.1523L0.830078 10.6523L10.8301 1.15234" stroke="#614141" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg width="19" height="16" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.17017 20.1523L11.1702 10.6523L1.17017 1.15234" stroke="#614141" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    dots: false,
    autoplay: true,
    speed: 500,
    infinite: true,
    autoplaySpeed: 2000,    
    responsive: [
      {
        breakpoint: 989,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  });

  // scroll text
  $('.text_slide').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows:false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 15000,
    pauseOnHover: true,
    cssEase: 'linear',
    swipeToSlide: true,
  	centerMode: true,
    focusOnSelect: true,
    variableWidth: true,
    responsive: [
        {
           breakpoint: 820,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
        },
        {
           breakpoint: 550,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: true
            }
        }
    ]
  });  

  
// collection list slider
  $('.coll_list_slider').slick({
    arrows:false,
    slidesToShow: 5,
    centerPadding: '60px',
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
        {
           breakpoint: 550,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
        }
    ]
  });
  // description tab
   $(".des_qt").click(function(){
      $(this).closest('.des_tabs').find(".des_ans").slideToggle();
      $(this).closest('.des_tabs').find(".itg_accordion_plus").toggleClass("minus");
      $(this).closest('.des_tabs').find(".itg_accordion_minus").toggleClass("plus");
   }); 
  
  // tab-with-icon
  $(".tab_sub_txt").click(function(){
    $(this).closest('.tab_qt_tb').find(".tab_qt_ans").slideToggle();
    $(this).closest('.tab_qt_tb').find(".plus_icon").toggleClass("minus");
    $(this).closest('.tab_qt_tb').find(".minus_icon").toggleClass("plus");
    
    // var id=$(this).closest('.tab_qt_tb').attr("id"); 	 	
    // $(".tab_qt_tb").not("#"+id).find(".tab_qt_ans").slideUp();
    // $(".tab_qt_tb").not("#"+id).find(".plus_icon").removeClass("minus");
    // $(".tab_qt_tb").not("#"+id).find(".minus_icon").removeClass("plus");
  });
  // buy it blog slider
  $('.buy_it_blg_slide').slick({
    arrow:false,
    dots: false,
    autoplay: true,
    infinite: true,
    speed: 300,
    autoplaySpeed: 2000,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows:false,
          dots: false
        }
      }
    ]
  });

// blog_tab data ajax  
  $(document).on("click","ul.blog_tab li",function(e) {
      e.preventDefault();     
      var tag_name = $(this).attr('data_ctm_tag');
      // var scrollURL = 'https://www.heathrilesbbq.com/blogs/favorite-recipes/tagged/beef';
      var scrollURL = $(this).attr('data_tag_url');
      $.ajax({
        type: "GET",
        url: scrollURL,
        success: function (data) {
         $('html, body').animate({
           scrollTop: $(".itg_blog").offset().top
         });
         
         if($(data).find(".itg_blog").length) {
            var blogs_data = $(data).find(".itg_blog").html();
            $(document).find(".itg_blog").html(blogs_data);
            $('.itg_blog_second').each(function(){
              $(this).find('.itg_blog_wrapper:gt(1)').hide();
            });
         }
          
        },
        dataType: "html",
      });
      // if(tag_name != ''){
      //    $('.itg_blog_articles').each(function() {
      //      var collName = $.trim($(this).attr('art_'+tag_name));
      //      if(collName == tag_name){
      //        $(this).show();
      //      }else{
      //        $(this).hide();
      //      }
           
      //    });
      // }
  });

  $('.itg_blog_second').each(function(){
    $(this).find('.itg_blog_wrapper:gt(1)').hide();
  });
  $(document).on("click",".blog_load_btn .load_btn",function() {
    var last = $('.blog-articles').children('.itg_blog_wrapper:visible:last');
    last.nextAll(':lt(2)').css('display','grid');
    last.next().prevAll().hide();
    // alert(last.nextAll().length);
    if (last.nextAll().length <=2  ){
       $('.blog_load_btn .load_btn').hide();
    }
    $('html, body').animate({
        scrollTop: $(".itg_blog_second").offset().top
    });
  });

  window.addEventListener("pageshow", function(event) {
      var historyTraversal =
          event.persisted ||
          (typeof window.performance != "undefined" &&
              window.performance.navigation.type === 2);
      if (historyTraversal) {
          // Handle page restore.
          window.location.reload();
      }
  });

$("#btnSbmt").click(function(e) {
      e.preventDefault();
      var len = 0;
      $(".line-item-property__itg.line_item_int input").each(function(e){  
        var int = $(this).val();        
        if(int == ''){ 
           len++;              
        }
      });
    // console.log(len);
        
      if(len == 0){
        // alert(len);
        $("#Submit_wlsal").trigger("click");
      }else{
        alert("Please fill in all the fialds")
      }
    return(len);
   });
 

  $(document).on("click",".custom_remove_item a",function() {
    
       var ths_packname = $(this).attr('data-pack');
       var dataupdate = { updates: {} };
      $("#main-cart-items .cart-item").each(function(index){
      	    var getNumber = $(this).attr('data-randnumber');
            if(getNumber == ths_packname){
               var variantid = $(this).attr('data-varid');
               var qty = 0;
          	   dataupdate.updates[variantid] = qty; 
            }
      }).promise().done( function(){
        
        jQuery.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: dataupdate,
            dataType: 'json',
            success: function(data) { 
               window.location.href = '/cart';
            },error: function(error){
              
            }
          }); 
 
      });
    
  });
  

   function LoopForever() {
  
      $('.satcb-cs-item-preorder').each(function() {
        var pack_name = $.trim($(this).find('span').text());
          if(pack_name == 'Pack: 4 pack'){
            $(this).closest('.satcb-cs-item').find(".satcb-cs-item-qty").css("pointer-events", "none");
          }
          if(pack_name == 'Pack: 8 pack'){
            $(this).closest('.satcb-cs-item').find(".satcb-cs-item-qty").css("pointer-events", "none");
          }
      });
  }
  var interval = self.setInterval(function(){LoopForever()},1000);


  
  function itgLoopForever() {
    if ($(".satcb-cs").hasClass("satcb-cs-open")) {
      // console.log('1');
      var titleCheck = $(document).find('.satcb-cs-upsell-item-atc[data-product="8144463331545"]');
      if (titleCheck.length) {
        // console.log("find");
        if (titleCheck.closest('.satcb-cs-upsell-item').hasClass('itg-changed')) {
          // console.log('added');
        } else {
          // console.log('add');
          // titleCheck.closest('.slick-slide').css('display', 'none');
          titleCheck.closest('.satcb-cs-upsell-item').addClass('itg-changed');
          titleCheck.closest('.satcb-cs-upsell-item-title').find('ignore-quick-action').attr('href', 'https://www.heathrilesbbq.com/pages/eightpack-bundle');
          titleCheck.css('display', 'none');
          titleCheck.closest('.satcb-cs-upsell-item-btn').append('<a class="satcb-cs-item-atc_itg" href="https://www.heathrilesbbq.com/pages/eightpack-bundle" data-product="7904152813785" tabindex="0">view product</a>');
        }
      }
    }
  }

  var bundle8 = setInterval(itgLoopForever, 1000);

    function itgLoopFor() {
    if ($(".satcb-cs").hasClass("satcb-cs-open")) {
      // console.log('1');
      var titleCheck = $(document).find('.satcb-cs-upsell-item-atc[data-product="8126424023257"]');
      if (titleCheck.length) {
        // console.log("find");
        if (titleCheck.closest('.satcb-cs-upsell-item').hasClass('itg-chngd')) {
          // console.log('added');
        } else {
          // console.log('add');
          // titleCheck.closest('.slick-slide').css('display', 'none');
          titleCheck.closest('.satcb-cs-upsell-item').addClass('itg-chngd');
          titleCheck.closest('.satcb-cs-upsell-item-title').find('ignore-quick-action').attr('href', 'https://www.heathrilesbbq.com/pages/bundle');
          titleCheck.css('display', 'none');
          titleCheck.closest('.satcb-cs-upsell-item-btn').append('<a class="satcb-cs-item-atc_itg" href="https://www.heathrilesbbq.com/pages/bundle" data-product="" tabindex="0">view product</a>');
        }
      }
    }
  }

  var bundle = setInterval(itgLoopFor, 1000);

});
